import React from "react";
import PaginacionTabla from "./PaginacionTabla";

export class Scroller extends React.Component {
  
  constructor(props) {
    super(props);

    this.state = {
      speciesName: this.props.speciesName,
      boatScores: this.props.boatScores,
      boatClass: this.props.boatClass,
      classBoats: [],
      tiles: this.props.tiles,
      itemsperpage: 5,
      nocolumns: 3
    }
  }
  
  componentWillReceiveProps(newProps) {
    this.setState({boatScores: newProps.boatScores, rowWidth: newProps.rowWidth, tiles: newProps.tiles, boatClass: newProps.boatClass, itemsperpage: newProps.itemsperpage, nocolumns: newProps.nocolumns});
      this.classFilter();
  }
    
  classFilter() {
      var scores = this.props.boatScores;
      var boatClass = this.props.boatClass;
      var classBoats = [];
      scores.forEach((boat) => {
        if(boat.boat.boatClass === boatClass && boat.boat.total > 0) {
          var lastF = this.getLastFishTime(boat.boat.speciesCounts);
          classBoats.push({
              id: boat.boat.id,
              boatClass: boat.boat.boatClass,
              boatName: boat.boat.boatName,
              boatThm: boat.boat.boatThm,
              lastFishTime: boat.boat.lastFishTime,
              lastSpeceiesFishTime: lastF[0],
              total: boat.boat.total
          });
        }
      })
      this.scoreSortFilter(classBoats);
  }
    
  getLastFishTime(times){
      var timesArray = [];
      times.forEach((time) => {
          if(time.speciesTimes){
              time.speciesTimes.forEach((t) => {
                  var secs = new Date(t).getTime() / 1000;
                  timesArray.push(secs);
              })
          }
      })
      timesArray.sort((a, b) => b - a);
      
      return timesArray;
  }
    
  scoreSortFilter(boatScores) {
    Array.prototype.sortOn = function(key, key2){
      this.sort(function(a, b){
          if(a[key] < b[key]){
              return -1;
          }else if(a[key] > b[key]){
              return 1;
          } else {
            if(a[key2] > b[key2]){
              return -1;
            }else if(a[key2] < b[key2]){
              return 1;
            }
          }
          return 0;
      });
    }
    boatScores.sortOn("total", "lastSpeceiesFishTime");
    boatScores.reverse();
    function isNumber(obj) {
      return obj!== undefined && typeof(obj) === 'number' && !isNaN(obj);
    }

    function filterByTotal(item) {
      if (isNumber(item.total)) {
        return true;
      } 
      return false; 
    }
    var boatScoresArray = boatScores.filter(filterByTotal);
    var rank = 1;
    var bScores = [];
    boatScoresArray.forEach((boat) => {
      bScores.push({
        rank: rank++,
        boat: boat
      })
    })

    this.setState({
        classBoats: bScores
    })
  }
  
render() {
  const boats = this.state.classBoats.map((boat, i) => {
        return <tr key={boat.boat.id}>
                <td className="pNameCell">{boat.boat.boatName}</td>
                <td className="pRankCell">{boat.rank}</td>
                <td className="pTotalCell">{boat.boat.total}</td>
              </tr>
              });
    return (
      <div className="pQueposCell"> 
      <div className="pQueposCellTitleBox">
        <div className="pQueposTitle">{this.props.boatClass} {this.props.speciesName} Division</div>
      </div>
      <div className="pQueposCellBox">
      {boats.length > 0 ? <table className="table table-hover">
        <thead>
          <tr>
            <th className="pNameCell">Boat</th>
            <th className="pRankCell">#</th>
            <th className="pTotalCell">Points</th>
          </tr>
        </thead>
        <PaginacionTabla
          itemsperpage={this.state.itemsperpage}
          nocolumns={this.state.nocolumns}
          items={boats}
          pagesspan={4}
        />
      </table> : <div className="pQueposTitle"> No Results Yet</div>}
      </div>
    </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/Scroller.js